
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legals/[uid]",
      function () {
        return require("private-next-pages/legals/[uid].tsx");
      }
    ]);
  